import React, { Component } from "react";
import "./style.less";
import { Table, Card } from "antd";
import InvoiceDetail from "../InvoiceDetail";
import { getInvoiceList } from "../../api/invoiceList";
import { formatInvoice } from "@/utils/format";

const clsPrefix = "c-order-list";
const columns = [
  {
    title: "申请时间",
    dataIndex: "createTime"
  },
  {
    title: "发票抬头",
    dataIndex: "invoiceTitle"
  },
  {
    title: "发票总额",
    dataIndex: "amount"
  },
  {
    title: "发票状态",
    dataIndex: "status"
  },
  {
    title: "开票方式",
    dataIndex: "invoiceWay"
  }
];

class InvoiceList extends Component {
  constructor() {
    super();
    this.state = {
      data: [],
      start: "",
      end: "",
      // 分页
      offset: 0,
      current: 1,
      total: 0
    };
  }

  getInvoiceListandRender = () => {
    getInvoiceList(this.state.offset)
      .then(res => {
        this.setState({
          total: res.count
        });
        return res.invoiceList.map(invoice => {
          return formatInvoice(invoice);
        });
      })
      .then(res => {
        const addedKeyInoviceList = res.map((item, index) => ({
          key: index + 1 + this.state.offset,
          ...item
        }));
        this.setState({
          data: addedKeyInoviceList
        });
      })
      .catch(err => console.log(err));
  };
  componentDidMount() {
    this.getInvoiceListandRender();
  }
  // 分页的实现
  changePage = page => {
    this.setState(
      {
        current: page
      },
      () => {
        this.setState(
          {
            offset: (this.state.current - 1) * 10
          },
          () => {
            this.getInvoiceListandRender();
          }
        );
      }
    );
  };

  render() {
    return (
      <div className={clsPrefix}>
        <div className="tableList">
          <Table
            className="tableBox"
            columns={columns}
            expandedRowRender={record => <InvoiceDetail record={record} />}
            dataSource={this.state.data}
            size="middle"
            pagination={{
              pageSize: 10,
              current: this.state.current,
              onChange: this.changePage,
              total: this.state.total
            }}
          />
          <span className="iconfont icon-iconfontzhizuobiaozhun023132">
            <Card className="prompt" title="提示" type="inner">
              <p>1、每月15日-次月14日间提交的开票申请，将在次月月底前寄到</p>
              <p>
                2、增值税普通发票开票金额小于500元或者增值税专用发票开票金额小于2000元需要支付快递费
              </p>
            </Card>
          </span>
        </div>
      </div>
    );
  }
}
export default InvoiceList;
